const L="NEXT_LOCALE",E="X-NEXT-INTL-LOCALE",o="locale";export{L as COOKIE_LOCALE_NAME,E as HEADER_LOCALE_NAME,o as LOCALE_SEGMENT_NAME};
